module.exports = __webpack_public_path__ + "static/media/12.fbd219c9.jpg";